var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 text-left",
    staticStyle: {
      "padding-right": "0px"
    }
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("user", 2)) + ": " + _vm._s(_vm.$Jed.firstUpperTranslate("row") + ' ' + _vm.currentRow + ' ' + _vm.$Jed.translate("of") + ' ' + _vm.maxRows))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 text-left",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addUserClick($event)
      }
    }
  }, [_c('i', {
    class: _vm.$root.icons.plus,
    staticStyle: {
      "font-size": "1.8em"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('grid', {
    attrs: {
      "others": _vm.others,
      "columns": _vm.otherRequesterAttributesCfg.columns,
      "source": _vm.usersList,
      "options": _vm.options,
      "lang": _vm.$root.token.idLingua,
      "name": _vm.otherRequesterAttributesCfg.title,
      "rowClick": _vm.rowClicked
    },
    on: {
      "update:source": function($event) {
        _vm.usersList = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "controls col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.otherRequesterLabels.annullaBtnLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.confirmClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.otherRequesterLabels.confermaBtnLbl))])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb688ab6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shopcart/OtherRequester.vue
// module id = 1702
// module chunks = 1